import type { ListingActionDto } from '@pulsify/shared/dto'
import * as m from '~/paraglide/messages'
import { Card } from '~/shared/ui/card'
import { actionDayLabel, actionStatusText } from '../lib/action-labels'
import { actionPushStatus } from '../lib/action-status'

export function ActionHistory({
  actions,
  locale,
}: {
  actions: ListingActionDto[]
  locale: 'de' | 'en'
}) {
  const now = new Date()
  return (
    <Card className="flex flex-col gap-4 p-6">
      <h2 className="font-semibold font-serif text-2xl text-foreground tracking-tight">
        {m.actionHistoryHeading()}
      </h2>
      {actions.length === 0 ? (
        <p className="text-muted-foreground text-sm">{m.actionHistoryEmpty()}</p>
      ) : (
        <ul className="flex flex-col divide-y">
          {actions.map((action) => (
            <li key={action.id} className="flex flex-col gap-1 py-3">
              <span className="text-muted-foreground text-xs">
                {actionDayLabel(action.localDate, locale)}
              </span>
              <span className="break-words text-foreground text-sm">{action.text}</span>
              <span className="text-muted-foreground text-xs">
                {actionStatusText(actionPushStatus(action, now))}
              </span>
            </li>
          ))}
        </ul>
      )}
    </Card>
  )
}
